module.exports = __webpack_public_path__ + "img/A18a_19960036-001_ongrey.262888d8.jpg";